import React, { useState } from "react";
import { COMPANY_META } from "../../data/constants";

export default function FirmChip({ name, showName = false, size }) {
  const meta = COMPANY_META[name] || { bg: "#333", color: "#fff", abbr: name.slice(0, 3).toUpperCase(), logo: null };
  const [imgFailed, setImgFailed] = useState(false);

  const iconSize = size || (showName ? 24 : 26);
  const radius   = showName ? 6 : 7;

  const logoEl = (!imgFailed && meta.logo) ? (
    <img src={meta.logo} alt={name} onError={() => setImgFailed(true)}
      style={{ width: iconSize, height: iconSize, borderRadius: radius, objectFit: "contain", background: "#fff", flexShrink: 0, display: "block", border: "0.5px solid #eee" }} />
  ) : (
    <div style={{ width: iconSize, height: iconSize, borderRadius: radius, background: meta.bg, color: meta.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: iconSize <= 24 ? 7 : 9, fontWeight: 700, fontFamily: "monospace", letterSpacing: "-0.02em", flexShrink: 0 }}>
      {meta.abbr}
    </div>
  );

  if (showName) {
    return (
      <div title={name} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(128,128,128,0.1)", borderRadius: 9, padding: "5px 11px 5px 7px" }}>
        {logoEl}
        <span style={{ fontSize: 12, fontWeight: 500 }}>{name}</span>
      </div>
    );
  }

  return <div title={name} style={{ display: "inline-flex", flexShrink: 0 }}>{logoEl}</div>;
}
